import productsMap from "./google-analytics-products-map"

window.dataLayer = window.dataLayer || []
window.analytics = function analytics() {
  dataLayer.push(arguments)
}
analytics("js", new Date())

document.addEventListener("DOMContentLoaded", () => {
  const googleAnalyticsId = document.querySelector("#ga-config").dataset.gaid
  if (!googleAnalyticsId) return

  setupAnalytics(googleAnalyticsId)
  viewItemList()
  viewItem()
  selectContent()
  addToCard()
})

const setupAnalytics = (googleAnalyticsId) => {
  analytics("config", googleAnalyticsId, {
    page_title: document.title,
    page_location: location.href,
    page_path: location.pathname,
  })
}

const emitAnalyticsEvent = (eventName, payload) => {
  analytics("event", eventName, payload)
}

const addToYlCart = (productId, price, quantity = 1) => {
  if (productId === 0) return

  window.ylData = window.ylData || []
  const ylData = window.ylData
  const products = [{ productId: productId, quantity: quantity, price: price }]
  ylData.push({ "cart.add": { products: products } })
}

const ylIdFromSampleName = (name) => {
  const ylMap = {
    "próbka forniru norwegian wood": 12,
    "próbka koloru terra": 13,
    "próbka koloru memphis": 14,
    "próbka modelu stripe": 15,
    "próbka modelu wave": 16,
    "norwegian wood single shelf": 28,
    "norwegian wood shelving unit": 29,
    "norwegian wood veneer sample": 30,
    "terra collection colour sample": 31,
    "memphis collection colour sample": 32,
    "stripe model sample": 33,
    "wave model sample": 34,
    "muster des norwegian wood furniers": 48,
    "muster der terra-farbe": 49,
    "memphis-farbmuster": 50,
    "muster des modells stripe": 51,
    "muster des modells wave": 52,
  }

  return ylMap[name.trim().toLowerCase()]
}

const ylIdFromShelfName = (name) => {
  const ylMap = {
    "Półka Norwegian Wood": 10,
    "Regał Norwegian Wood": 11,
    "Norwegian Wood Single Shelf": 28,
    "Norwegian Wood Shelving Unit": 29,
    "Fach Norwegian Wood": 46,
    "Regale Norwegian Wood": 47,
  }

  return ylMap[name]
}

const ylIdFront = (model, category) => {
  const locale = getLocale()

  const frontsMap = window.ylFrontsMap
  if (!frontsMap) return null

  if (
    frontsMap[category] &&
    frontsMap[category][model] &&
    frontsMap[category][model][locale]
  ) {
    return frontsMap[category][model][locale]
  }

  return null
}

const getLocale = () => {
  const locale = window.location.pathname.split("/")[1]
  const locales = ["pl", "en", "de"]
  return locales.includes(locale) ? locale : "pl"
}

const viewItemList = () => {
  emitEventByAttributeTag({ tag: "[data-gtag-list]" })
}

const viewItem = () => {
  emitEventByAttributeTag({ tag: "[data-gtag-item]" })
}

const selectContent = () => {
  emitEventByAttributeTag({ tag: "[data-gtag-click]", clickable: true })
}

const addToCard = () => {
  shelvingItemsByForm({
    formId: "#shelving_concept_single_shelf_form",
    name: "Norwegian Wood Single Shelf",
  })
  shelvingItemsByForm({
    formId: "#shelving_concept_shelving_unit_form",
    name: "Norwegian Wood Shelving Units",
  })
  samplesByForm()
  saveFromConfigurator()
}

const purchase = () => {
  summaryOrderAndPay()
}

const getCategoryByCollection = (collection) => {
  switch (collection) {
    case "terra":
    case "memphis":
      return "fronts/lacquered"
    case "norwegian-wood":
      return "fronts/veneered"
    case "artisan":
      return "fronts/veneered-coloured"
  }
}

const getCurrency = (currency) => {
  return currency === "zł" ? "PLN" : currency
}

const emitEventByAttributeTag = ({ tag, clickable = false }) => {
  const items = document.querySelectorAll(tag)
  if (items.length === 0) return

  for (let i = 0; i < items.length; i++) {
    const item = items[i]
    const product = productsMap[item.dataset.gtagData]

    if (clickable) {
      item.addEventListener("click", (event) => {
        emitAnalyticsEvent(product.eventName, {
          content_type: product.content_type,
          items: product.items,
        })
      })
    } else {
      emitAnalyticsEvent(product.eventName, {
        items: product.items,
      })
    }
  }
}

const shelvingItemsByForm = ({ formId, name }) => {
  const form = document.querySelector(formId)
  if (!form) return

  form.addEventListener("submit", (event) => {
    const gaData = event.target.querySelector(".ga-sample-data")
    const variant = event.target.querySelector(
      'input[name="color"]:checked',
    ).value
    const { price, currency, nameI18n } = gaData.dataset
    if (!gaData) return

    emitAnalyticsEvent("add_to_cart", {
      currency: getCurrency(currency),
      items: [
        {
          name: name,
          category: "shelving",
          variant: variant,
          quantity: 1,
          price: price,
        },
      ],
    })

    const ylId = ylIdFromShelfName(nameI18n)
    addToYlCart(ylId, price)
  })
}

const samplesByForm = () => {
  const forms = document.querySelectorAll("#new_stock_product_order_line_item")
  if (forms.length === 0) return

  for (let i = 0; i < forms.length; i++) {
    const form = forms[i]

    form.addEventListener("submit", (event) => {
      const gaData = event.target.querySelector(".ga-sample-data")
      if (!gaData) return

      const { name, category, price, currency, nameI18n } = gaData.dataset

      if (category === "samples") {
        const variant = event.target.querySelector(
          'input[name="stock_product_order_line_item[color_id]"]:checked',
        ).dataset.color
        emitAnalyticsEvent("add_to_cart", {
          currency: getCurrency(currency),
          items: [
            {
              name: name,
              category: category,
              variant: variant,
              quantity: 1,
              price: price,
            },
          ],
        })
        const ylId = ylIdFromSampleName(nameI18n)
        addToYlCart(ylId, price)
      } else {
        emitAnalyticsEvent("add_to_cart", {
          currency: getCurrency(currency),
          items: [
            {
              name: name,
              category: category,
              quantity: 1,
              price: price,
            },
          ],
        })
      }
    })
  }
}

const saveFromConfigurator = () => {
  const saveConfigButton = document.querySelector("#save_config_button")
  if (!saveConfigButton) return
  saveConfigButton.addEventListener("click", (event) => {
    let name = ""
    let category = ""

    const system = getValueFromConfiguratorField({
      inputName:
        'input[name="front_order_line_item[front_attributes][system_id]"]:checked',
      labelFor: "front_order_line_item_front_attributes_system_id",
    })

    if (system === "furniture-collection") {
      const furniture = getValueFromConfiguratorField({
        inputName:
          'input[name="front_order_line_item[front_attributes][type_id]"]:checked',
        labelFor: "front_order_line_item_front_attributes_type_id",
      })

      name =
        furniture === "shelving-unit"
          ? "Norwegian Wood Shelving Unit"
          : "Norwegian Wood Single Shelf"
      category = "shelving"
    } else {
      name = getValueFromConfiguratorField({
        inputName:
          'input[name="front_order_line_item[front_attributes][model_id]"]:checked',
        labelFor: "front_order_line_item_front_attributes_model_id",
      })
      const collection = getValueFromConfiguratorField({
        inputName: 'input[name="front_order_line_item[collection_id]"]:checked',
        labelFor: "front_order_line_item_collection_id",
      })
      category = getCategoryByCollection(collection)
    }

    const variant = getValueFromConfiguratorField({
      inputName: 'input[name="front_order_line_item[color_id]"]:checked',
      labelFor: "front_order_line_item_color_id",
    })
    const { price, currency, quantity } = getPriceCurreencyAndQuantity()

    emitAnalyticsEvent("add_to_cart", {
      currency: getCurrency(currency),
      items: [
        {
          name: name,
          category: category,
          quantity: quantity,
          variant: variant.trim(),
          price: price,
        },
      ],
    })
    const ylId = ylIdFront(name, category)
    addToYlCart(ylId, price, quantity)
  })
}

const summaryOrderAndPay = () => {
  const buttton = document.querySelector("#final_order_pay_button")
  if (!buttton) return
  buttton.addEventListener("click", (event) => {
    const gaItemsData = document.querySelectorAll(".ga-sample-data")
    if (gaItemsData.length === 0) return

    const items = []
    const currency = gaItemsData[0].dataset.currency

    for (let i = 0; i < gaItemsData.length; i++) {
      const { name, category, quantity, variant, price } =
        gaItemsData[i].dataset

      items.push({
        name: name,
        category: category,
        variant: variant,
        quantity,
        price,
      })
    }

    emitAnalyticsEvent("purchase", {
      currency: getCurrency(currency),
      items,
    })
  })
}

const getPriceCurreencyAndQuantity = () => {
  const priceLabel = document.querySelector(".AmountPrice__price").textContent
  const priceLabelValues = priceLabel.split(" ")
  const price = priceLabelValues[0]
  const currency = priceLabelValues[1]
  const quantity = document.querySelector(
    'input[name="front_order_line_item[quantity]"]',
  ).value
  return { price, currency, quantity }
}

const getValueFromConfiguratorField = ({ inputName, labelFor }) => {
  const id = document.querySelector(inputName).value
  const value = document.querySelector(`label[for="${labelFor}_${id}"]`).dataset
    .selectedValue
  return value
}
